import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React, { useContext } from 'react';
import { cx } from 'emotion';
import { StylesProvider as OriginalStylesProvider, StylesContext } from '@rexlabs/element-styles';
export function StylesProvider(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var context = useContext(StylesContext);
  return /*#__PURE__*/React.createElement(OriginalStylesProvider, _extends({
    mergeClasses: (context === null || context === void 0 ? void 0 : context.mergeClasses) || cx
  }, props), children);
}
export default StylesProvider;